const CHARS = 'abcdefghijklmnopqrstuvwxyz!@#$%^&*()_+';
const SPEED = 50;

document.querySelectorAll('.header__body .navmenu a').forEach(link => {
  const originalText = link.textContent;
  let interval = null;
  let iteration = 0;
  let originalWidth = null;

  link.addEventListener('mouseenter', () => {
    clearInterval(interval);
    iteration = 0;

    originalWidth = link.getBoundingClientRect().width;
    link.style.maxWidth = `${originalWidth}px`;
    link.style.minWidth = `${originalWidth}px`;

    interval = setInterval(() => {
      link.textContent = originalText
        .split('')
        .map((char, i) => {
          if (char === ' ') return ' ';
          if (i < iteration) return originalText[i];
          return CHARS[Math.floor(Math.random() * CHARS.length)];
        })
        .join('');

      iteration += 0.5;

      if (iteration >= originalText.length) {
        clearInterval(interval);
        link.textContent = originalText;
      }
    }, SPEED);
  });

  link.addEventListener('mouseleave', () => {
    clearInterval(interval);
    link.textContent = originalText;

    link.style.maxWidth = '';
    link.style.minWidth = '';
  });
});
